module.exports = __webpack_public_path__ + "static/media/user-music.d4fd5dbc.svg";